import { Typography, useTheme } from '@mui/material';
import { Box } from '@mui/system';
import { HeaderPage4 } from 'theme/elements/Headers';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectImageUrl, selectTranslations } from 'state/reducers/translation.reducers';

export default function EmptyNotifications() {
	const theme = useTheme();
	const t = useAppSelector(selectTranslations);
	const imageUrl = useAppSelector(selectImageUrl);
	const prefixFields = 'header.notifications.empty.';

	return (
		<Box
			sx={{
				marginBlock: '12px',
				padding: '0 15px',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
			}}
		>
			<img
				src={imageUrl(`${prefixFields}icon` || '') || '/static_images/brand-image-4.png'}
				width="70%"
				height="70%"
				alt=""
			/>
			<Box sx={{ textAlign: 'center', marginTop: '25px' }}>
				<HeaderPage4 title={t(`${prefixFields}title`)} />
				<Box sx={{ display: 'flex', flexDirection: 'column' }}>
					<Typography variant="body3" sx={{ color: theme.palette.root.basicDeepBlue }}>
						{t(`${prefixFields}subtitle`)}
					</Typography>
					<Typography variant="body3" sx={{ color: theme.palette.root.basicDeepBlue }}>
						{t(`${prefixFields}later`)}
					</Typography>
				</Box>
			</Box>
		</Box>
	);
}
